import * as Types from '../../../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CashierNamesQueryVariables = Types.Exact<{
  ids: ReadonlyArray<Types.InputMaybe<Types.Scalars['String']>> | Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CashierNamesQuery = { readonly __typename?: 'Query', readonly usersById?: ReadonlyArray<{ readonly __typename?: 'User', readonly _id: string, readonly person?: { readonly __typename?: 'UserPerson', readonly firstname?: string | null, readonly lastname?: string | null } | null } | null> | null };


export const CashierNamesDocument = gql`
    query CashierNames($ids: [String]!) {
  usersById(ids: $ids) {
    _id
    person {
      firstname
      lastname
    }
  }
}
    `;

/**
 * __useCashierNamesQuery__
 *
 * To run a query within a React component, call `useCashierNamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCashierNamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCashierNamesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useCashierNamesQuery(baseOptions: Apollo.QueryHookOptions<CashierNamesQuery, CashierNamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CashierNamesQuery, CashierNamesQueryVariables>(CashierNamesDocument, options);
      }
export function useCashierNamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CashierNamesQuery, CashierNamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CashierNamesQuery, CashierNamesQueryVariables>(CashierNamesDocument, options);
        }
export type CashierNamesQueryHookResult = ReturnType<typeof useCashierNamesQuery>;
export type CashierNamesLazyQueryHookResult = ReturnType<typeof useCashierNamesLazyQuery>;
export type CashierNamesQueryResult = Apollo.QueryResult<CashierNamesQuery, CashierNamesQueryVariables>;